var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSun(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 515.41 511.24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-7{fill:#f2d33b;}.cls-1{opacity:0.1;}.cls-2{fill:#ed6326;}.cls-3{fill:#ef8a34;}.cls-4{fill:#edba3a;}.cls-5{fill:#ffff43;}.cls-5,.cls-7{opacity:0.3;}.cls-6{fill:#fff;opacity:0.2;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 257.71,
    cy: 255.62,
    rx: 257.71,
    ry: 255.62
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 259.71,
    cy: 254.43,
    r: 168.93,
    transform: "translate(-103.85 258.16) rotate(-45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M132.74,193.75c39.35-11.08,68-37.9,103.27-57.17,13.25-7.24,26.84-6.68,40.32-10.43,16.13-4.5,30.9-13.58,45.38-21.53,2.63-1.44,5.4-2.9,8.27-4.31A169,169,0,0,0,96.88,206.19C109.83,200.17,124.43,196.09,132.74,193.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M253.63,293.27C275,286,291.52,272.49,310,259.13c21.35-15.47,42.24-30.35,62-47.27,10.66-9.13,26.55-21,41.12-27.62a168.83,168.83,0,0,0-15.4-27.1c-7.15,9.65-18.23,17.65-31.12,23.46-37.92,17.07-71.49,25-104.18,52.53-27.22,22.92-56,45.2-86.84,63.08-18.21,10.54-37.06,23.76-57.94,27.62a93.78,93.78,0,0,1-11.69,1.27,169.11,169.11,0,0,0,22,35.13c26.52-12.42,48-30.9,74.39-46.68C219,303.63,235.65,299.34,253.63,293.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M391.93,232.75c-47.14,33.53-90.71,70.65-135.24,107.3-26,21.42-50.29,43.91-77.47,62.52A169,169,0,0,0,423.08,213.15C412.54,220.71,399.13,227.63,391.93,232.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M105.66,232c3.81-3.95,8.82-5.61,13.92-7.26,5.33-1.73,10.34-3.64,14.8-7.1,3.85-3-1.55-8.29-5.34-5.34-4.18,3.24-9.57,4.49-14.49,6.14-5.3,1.78-10.31,4.14-14.23,8.22-3.38,3.51,2,8.86,5.34,5.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M121.63,233c15.2,4,26.64-8.63,34.5-19.87,2.8-4-3.75-7.78-6.52-3.82-5.74,8.22-14.59,19.38-26,16.41-4.72-1.24-6.72,6.05-2,7.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M105.25,258.06c.13-1.65,3.66-3.08,4.88-3.57a14.07,14.07,0,0,1,7.72-1.1c4.76,1,6.78-6.3,2-7.29-8-1.65-21.41,2.38-22.16,12-.38,4.86,7.18,4.82,7.55,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M110.55,269.4c7.63.69,15.11-1.08,20.81-6.4,3.56-3.34-1.79-8.67-5.35-5.35-4.26,4-9.86,4.7-15.46,4.19-4.86-.45-4.82,7.12,0,7.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M131.2,247.34a29.6,29.6,0,0,1,10.33-2.13c4.87-.07,4.88-7.63,0-7.56a35.45,35.45,0,0,0-12.34,2.41,3.85,3.85,0,0,0-2.64,4.64c.51,1.84,2.73,3.38,4.65,2.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M106.26,245.08l9.07-2.27c4.73-1.18,2.72-8.47-2-7.29l-9.07,2.27c-4.73,1.18-2.72,8.47,2,7.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M147.83,257.92a81.82,81.82,0,0,0,19-7.93c4.25-2.39.44-8.92-3.82-6.53a73.27,73.27,0,0,1-17.23,7.18c-4.71,1.24-2.71,8.53,2,7.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M172,228.22c4-5.57,12.47-5.66,18.66-5.68,4.87,0,4.87-7.58,0-7.56-9.38,0-19.3,1.31-25.18,9.43-2.87,4,3.69,7.72,6.52,3.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M215.09,226.18a25.82,25.82,0,0,0,12.25-7c3.5-3.4-1.85-8.74-5.34-5.34a18.43,18.43,0,0,1-8.92,5.07c-4.75,1.06-2.74,8.35,2,7.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M193.32,203.88c3.24-1.59,6.59-2.94,9.83-4.53a3.79,3.79,0,0,0,1.35-5.17,3.85,3.85,0,0,0-5.17-1.36c-3.24,1.6-6.59,2.94-9.82,4.54a3.8,3.8,0,0,0-1.36,5.17,3.85,3.85,0,0,0,5.17,1.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M170.65,198.59c2.18-1.41,4.62-2.36,6.8-3.78a3.78,3.78,0,1,0-3.81-6.52c-2.19,1.41-4.62,2.36-6.81,3.78a3.78,3.78,0,0,0,3.82,6.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M207.68,178.19a43.17,43.17,0,0,1,8.92-5.67c1.9-.79,3.24-2.47,2.64-4.65-.49-1.8-2.74-3.43-4.65-2.64a49.42,49.42,0,0,0-10.72,6.43c-1.65,1.23-2.49,3.24-1.36,5.17,1,1.62,3.52,2.59,5.17,1.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M225.07,187.42l.26-.23-.77.6a6.89,6.89,0,0,1,1-.6,7.4,7.4,0,0,0,1.77-1.28,3.78,3.78,0,1,0-5.34-5.35l-.26.23.77-.59a6,6,0,0,1-1,.59,7.51,7.51,0,0,0-1.77,1.29,3.78,3.78,0,1,0,5.34,5.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M249.26,222.19a52.08,52.08,0,0,1,9.81-7c4.18-2.51.38-9-3.81-6.53a61.25,61.25,0,0,0-11.35,8.15c-3.49,3.41,1.85,8.75,5.35,5.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M298.38,193.3c3.3-2,6.71-3.76,9.82-6a3.87,3.87,0,0,0,1.36-5.18c-1-1.63-3.51-2.57-5.17-1.35-3.11,2.28-6.52,4.08-9.83,6.05-4.18,2.49-.38,9,3.82,6.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M303.52,167.23c2-.69,4-1.57,6-2.27a3.84,3.84,0,0,0,2.64-4.65,3.78,3.78,0,0,0-4.64-2.63c-2,.69-4,1.57-6.05,2.26a3.85,3.85,0,0,0-2.64,4.65,3.8,3.8,0,0,0,4.65,2.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M309.71,134.35c2.82-1.43,5.5-3.1,8.32-4.53,4.34-2.21.51-8.73-3.82-6.53-2.82,1.43-5.5,3.11-8.31,4.53-4.35,2.21-.52,8.73,3.81,6.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M108.9,300.63c1.14-6.37,7-5.85,12.27-5.35s11.46,2.17,16.83.43c4.62-1.49,2.64-8.79-2-7.29-5.88,1.91-13.32-.91-19.38-.95-7.37-.05-13.63,3.53-15,11.15-.85,4.77,6.43,6.8,7.29,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M111,285.67c6.27-5.27,15.21-5.66,23-5.69,4.88,0,4.88-7.58,0-7.56-10.06,0-20.39,1.21-28.36,7.91-3.74,3.14,1.64,8.45,5.34,5.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M145.56,285.13c6.94-1.1,13-5.57,17.54-10.8,3.16-3.67-2.16-9-5.35-5.34-3.75,4.37-8.39,7.93-14.2,8.85-4.8.77-2.76,8.05,2,7.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M159.92,267a29.6,29.6,0,0,1,10.33-2.13c4.87-.07,4.88-7.63,0-7.56a35.67,35.67,0,0,0-12.34,2.4,3.86,3.86,0,0,0-2.64,4.65c.51,1.84,2.73,3.39,4.65,2.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M196.34,268.12a20.63,20.63,0,0,0,5.3-3.61,3.78,3.78,0,0,0-5.34-5.34c-.33.31-.66.61-1,.9.67-.55-.35.21-.49.3-.73.46-1.5.84-2.27,1.23a3.78,3.78,0,1,0,3.81,6.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M188.8,250.15c5.65-6,16.72-9.07,24.14-4.7,4.2,2.48,8-4,3.81-6.53-10.28-6-25.34-2.58-33.3,5.89-3.33,3.54,2,8.9,5.35,5.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M118.45,309.1c13.23,10.36,31.77-3.49,43.13-10.75,4.09-2.61.3-9.15-3.82-6.52a174.13,174.13,0,0,1-16.06,9.55c-4.63,2.3-13.06,6.17-17.9,2.38-3.79-3-9.18,2.34-5.35,5.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M145.55,370.31c4.46-7,12.63-9.73,20.42-11.11,4.79-.85,2.75-8.13-2-7.29-9.84,1.74-19.39,5.9-24.93,14.59-2.63,4.12,3.91,7.9,6.52,3.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M162.19,375.83c7.22-1.77,13.55-5.55,19.79-9.45,4.13-2.58.34-9.12-3.81-6.53-5.71,3.56-11.39,7.07-18,8.69-4.73,1.15-2.73,8.44,2,7.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M190.31,346.89c2.15-2.08,4.9-3.37,7.55-4.7a3.79,3.79,0,0,0,1.35-5.17,3.85,3.85,0,0,0-5.17-1.36,35.58,35.58,0,0,0-9.08,5.89c-3.51,3.38,1.84,8.72,5.35,5.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M219.77,339.92c4.07-2.46,8-5.1,12.1-7.55s.36-9.06-3.82-6.53-8,5.1-12.09,7.56-.37,9.05,3.81,6.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M202.39,366.38c4.54-2.83,8.34-6.66,12.1-10.42,3.45-3.45-1.89-8.79-5.34-5.35s-6.59,6.76-10.57,9.24c-4.13,2.57-.34,9.11,3.81,6.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M185.76,386a25.62,25.62,0,0,0,6.06-4.37,3.78,3.78,0,0,0-5.35-5.35c-.31.31-.64.61-1,.9l-.54.44c.6-.48-.31.21-.36.24A20.91,20.91,0,0,1,182,379.5a3.81,3.81,0,0,0-1.36,5.17,3.85,3.85,0,0,0,5.17,1.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M269.5,317.41c1.53-3.47,5.38-5.13,8.47-7,4.18-2.49.38-9-3.82-6.53s-9.11,5-11.18,9.67c-.83,1.89-.57,4,1.36,5.17,1.62.95,4.34.53,5.17-1.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M235.5,313.85c4.93-1.76,9.13-4.8,13.75-7.18,4.33-2.23.51-8.75-3.82-6.53-4,2.06-7.68,4.9-11.94,6.42-4.56,1.63-2.59,8.93,2,7.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M296.86,286.26c3.42-2.07,6.64-4.41,9.83-6.8,1.64-1.23,2.48-3.24,1.35-5.17-1-1.62-3.51-2.59-5.17-1.36-3.19,2.4-6.41,4.73-9.82,6.81-4.16,2.52-.36,9.06,3.81,6.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M327.09,259.81c2.56-1.72,5-3.57,7.56-5.29a3.84,3.84,0,0,0,1.36-5.17,3.8,3.8,0,0,0-5.17-1.36c-2.55,1.72-5,3.58-7.56,5.29a3.84,3.84,0,0,0-1.36,5.17,3.79,3.79,0,0,0,5.17,1.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M391.34,227.48a20,20,0,0,1,2.64-2.25,15.31,15.31,0,0,1,1.51-.89l.76-.37c-.27.13-.19.11.23-.06a3.84,3.84,0,0,0,2.64-4.64,3.79,3.79,0,0,0-4.65-2.64,22.93,22.93,0,0,0-8.47,5.5c-3.48,3.42,1.87,8.76,5.34,5.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M403.43,205.39c2-1.31,4.06-2.46,6-3.77a3.85,3.85,0,0,0,1.36-5.18,3.8,3.8,0,0,0-5.17-1.35c-2,1.31-4.06,2.47-6.05,3.78a3.78,3.78,0,0,0,3.82,6.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M255.29,166.85a148.83,148.83,0,0,0,15.12-8.31c4.06-2.66.28-9.21-3.81-6.53a148.83,148.83,0,0,1-15.12,8.31c-4.36,2.18-.53,8.7,3.81,6.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M237.16,151.73a85.79,85.79,0,0,1,8.31-5.29c4.34-2.22.51-8.74-3.81-6.52a81.16,81.16,0,0,0-8.32,5.29,3.84,3.84,0,0,0-1.35,5.17,3.8,3.8,0,0,0,5.17,1.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M267.39,141.91c2.16-1.06,4.27-1.92,6.05-3.62A3.78,3.78,0,0,0,268.1,133a4.91,4.91,0,0,1-.48.43c.35-.26.34-.26,0,0a12.73,12.73,0,0,1-1.39.79c-.87.45-1.77.81-2.65,1.23a3.8,3.8,0,0,0-1.35,5.17,3.85,3.85,0,0,0,5.17,1.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M244.72,192.71a34.71,34.71,0,0,1,5.28-3.94,3.84,3.84,0,0,0,1.36-5.17,3.8,3.8,0,0,0-5.17-1.36,46.69,46.69,0,0,0-6.81,5.13,3.78,3.78,0,0,0,5.34,5.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M347.5,170.63a79.35,79.35,0,0,0,13.61-8.15c1.63-1.27,1.32-4,0-5.34-1.59-1.6-3.72-1.27-5.34,0-3.67,2.85-7.95,4.89-12.08,7-4.36,2.18-.53,8.7,3.81,6.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M377.74,165.5a13.07,13.07,0,0,1,4.38-2.8,3.86,3.86,0,0,0,2.64-4.65,3.8,3.8,0,0,0-4.65-2.64,20.81,20.81,0,0,0-7.71,4.75,3.78,3.78,0,0,0,5.34,5.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M165.37,287.18c3.07-2.48,7.08-2.44,10.82-2.74,4-.3,7.77-1.14,11.09-3.47,3.95-2.78.18-9.34-3.82-6.52-3.51,2.47-7.47,2.4-11.59,2.78A20.92,20.92,0,0,0,160,281.84c-3.79,3.06,1.59,8.38,5.35,5.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M114.56,315.86a8.6,8.6,0,0,1-1.88-6.92A3.85,3.85,0,0,0,110,304.3c-1.85-.51-4.29.61-4.65,2.64A16,16,0,0,0,108,319.67a3.86,3.86,0,0,0,5.17,1.36c1.65-1,2.56-3.5,1.35-5.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M104.36,281.24c-.6-3.68-1.18-7.5,1.14-10.69,2.86-4-3.7-7.72-6.53-3.82-3.54,4.88-2.81,10.93-1.89,16.52.79,4.8,8.07,2.76,7.28-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M157.16,383.91c3.73,5.56,12.59.75,15.76-3a3.84,3.84,0,0,0,0-5.34,3.78,3.78,0,0,0-5.34,0,10.45,10.45,0,0,1-3.69,2.76,9.29,9.29,0,0,1-1.63.47c.68-.16-.28,0-.4,0l.43.08q-1.33-.39,1.4,1.21c-2.7-4-9.25-.25-6.53,3.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M176.16,346.73c.07-.19.14-.39.22-.59q-.27.63,0,0a10.56,10.56,0,0,1,.82-1.37c-.28.35-.28.35,0,0a5.89,5.89,0,0,1,.67-.65c-.37.27-.37.28,0,.05.15-.11,1-.45.21-.15a3.85,3.85,0,0,0,2.64-4.65,3.79,3.79,0,0,0-4.65-2.64c-3.69,1.36-5.91,4.31-7.17,7.93a3.78,3.78,0,1,0,7.28,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M187.39,371.29c4.37.84,8.86,2.37,13.36,1.84,5.61-.65,9.17-4.65,11.31-9.62,1.9-4.43-4.61-8.28-6.53-3.82-1.28,3-2.72,5.84-6.28,6-3.28.16-6.66-1.09-9.85-1.7-4.77-.91-6.8,6.38-2,7.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M228.84,351.26c2.86-2.17,5.47-4.64,8.32-6.8,1.63-1.25,2.49-3.23,1.35-5.17-.94-1.62-3.52-2.61-5.17-1.36-2.85,2.17-5.46,4.64-8.31,6.8-1.64,1.25-2.49,3.23-1.36,5.17,1,1.62,3.53,2.61,5.17,1.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M208.66,346c1.72-5.22,3-10.59,2.4-16.12-.54-4.79-8.1-4.84-7.55,0s-.61,9.46-2.14,14.11,5.78,6.62,7.29,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M209.2,326.48c.84-1,3.36-1.67,5-2.16,2.32-.71,4.69-1.29,7-2.16,4.5-1.71,2.55-9-2-7.28-2.72,1-5.56,1.7-8.33,2.57-2.36.75-5.33,1.68-6.94,3.69-1.29,1.61-1.58,3.77,0,5.34,1.33,1.34,4,1.61,5.34,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M243.21,328a30.76,30.76,0,0,1,7.55-5.46c4.34-2.23.51-8.75-3.81-6.53a37.54,37.54,0,0,0-9.08,6.64c-3.48,3.42,1.86,8.76,5.34,5.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M247.75,338.58a132.42,132.42,0,0,1,10.58-9.07c1.61-1.29,1.33-4,0-5.35-1.58-1.57-3.74-1.28-5.35,0a136.35,136.35,0,0,0-10.58,9.07c-3.47,3.43,1.88,8.77,5.35,5.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M130.7,208.8c9.78,2.64,18.47-6.32,28.22-5.91,4.87.2,4.85-7.36,0-7.56s-9.29,1.2-13.7,2.91c-3.62,1.4-8.51,4.35-12.51,3.27-4.71-1.27-6.71,6-2,7.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M150.85,240.54c2.45-.8,5.23-.33,7.76-.18a30,30,0,0,0,8.87-.57c4.73-1.15,2.72-8.44-2-7.29-5.46,1.32-11.23-1-16.63.75-4.61,1.52-2.63,8.82,2,7.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M181.23,234.87c3.24-1.6,6.59-2.94,9.82-4.54a3.8,3.8,0,0,0,1.36-5.17,3.85,3.85,0,0,0-5.17-1.35c-3.24,1.59-6.59,2.94-9.83,4.53a3.79,3.79,0,0,0-1.35,5.17,3.85,3.85,0,0,0,5.17,1.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M179.32,260.33a26.67,26.67,0,0,0,7.81-.89,3.78,3.78,0,1,0-2-7.29,19,19,0,0,1-5.8.62,3.78,3.78,0,0,0,0,7.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M202.75,257.3a36.19,36.19,0,0,0,15.51-3.54c4.4-2.09.56-8.61-3.81-6.52a27.43,27.43,0,0,1-11.7,2.51c-4.87.05-4.87,7.61,0,7.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M228.85,248.64l11.34-11.34c3.45-3.45-1.9-8.79-5.35-5.34q-5.66,5.67-11.33,11.33c-3.45,3.45,1.89,8.8,5.34,5.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M103.39,216.9c4.26-3.43,9.37-5.59,14.35-7.73,1.9-.81,2.3-3.56,1.36-5.17-1.14-1.94-3.28-2.17-5.17-1.35-5.67,2.43-11.05,5-15.88,8.9-3.8,3.06,1.59,8.37,5.34,5.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M196.59,218.91A168.63,168.63,0,0,1,261.83,85.55c-1.21,0-2.42,0-3.63,0A168.94,168.94,0,1,0,361.89,387.8,168.93,168.93,0,0,1,196.59,218.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M339.59,254.06c-15.2-12.82-35.45-10.39-53.7-7.52-15.16,2.38-72.87,11-71-16.65,1.53-23.24,36.49-29.08,29.69-57.23-1.82-7.57-15.45-14.93-15.39-21.17,0-5,14.08-11.46,18.23-13.8,7.45-4.22,27.08-13.36,9.79-18.69l-9.07-9.07c-6.33-11.2-31.64.15-40.06,3.78-13.16,5.67-26.71,15.19-34.64,27.37-5,7.63-2.76,15.68-6.13,24-4.32,10.71-14.11,17.47-21.77,25.66-9.39,10-18.54,19.87-24.41,32.49-11.22,24.12-6.27,55.64,24.39,58.26,9.49.81,29.26-4.52,36,4.49,7.08,9.51-4.15,27.51-8.19,35.79C146.07,377.47,208.56,391,233,375.36c14.39-9.22,7.59,25.54,34.8,18,12.73-3.53,39.91-19.55,49.12-28,21.1-19.24,27.73-30.65,39.05-59.28C363.35,287.34,354.56,266.68,339.59,254.06Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-7",
    cx: 258.84,
    cy: 255.62,
    rx: 197.65,
    ry: 194.4
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSun);
export default __webpack_public_path__ + "static/media/sun.0f310d0c661ecb08571a6a7f731d65dc.svg";
export { ForwardRef as ReactComponent };